'use strict';

const jQuery = require('jquery');

const FormBuilder = require('./../../builder');

let ElementClass = require('./../../elementClass');

const tplThemeColorElement = require('./template/theme_color_element.hbs');

FormBuilder.register('themeColorElement', function(config) {
   let self = new ElementClass(config);
   let $container;

   self.render = function() {
      $container = jQuery(tplThemeColorElement({
         'value': self.config.uniqueName,
         'label': 'theme_' + self.config.uniqueName,
         'primary': self.config.primary,
         'secondary': self.config.secondary,
         'textColor': self.config.textColor,
         'backgroundColor': self.config.backgroundColor,
         'isChecked': self.config.isChecked,
      }));

      $container.find('input[type=radio]').on('click', function() {
         let $input = jQuery(this);
         $input.prop('checked', true);
         $container.find('.theme-color-panel').addClass('checked');

         $container.parent().siblings().each(function() {
            let $currentElement = jQuery(this);
            let $currentInput = $currentElement.find('input[type=radio]');

            if ($currentInput.length === 1) {
               $currentInput.prop('checked', false);
               $currentElement.find('.theme-color-panel').removeClass('checked');
            }
         });
      });

      return $container;
   };

   self.getData = function() {
      let data = null;

      $container.find('input[type=radio]').each(function() {
         let $input = jQuery(this);

         if ($input.is(':checked')) {
            data = $input.val();

            return false;
         }
      });

      return data;
   };

   return self;
});
